import type { ImageWithAlt } from '../types';

export function getImageAlt(image: ImageWithAlt): string {
  return image.alt || image.asset.altText || '';
}
